import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { useTranslation } from 'react-i18next';
import type { components } from '../../../../Api/types/openapi';

type UserSimpleResponse = components['schemas']['UserSimpleResponse'];

interface DeleteConfirmModalProps {
  isOpen: boolean;
  toggle: () => void;
  user: UserSimpleResponse | null;
  onConfirm: () => void;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  toggle,
  user,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t('Confirmar Eliminación')}</ModalHeader>
      <ModalBody>
        <p>
          {t('¿Estás seguro de que deseas eliminar al usuario')}{' '}
          <strong>{user?.name || user?.email || `ID: ${user?.id}`}</strong>?
        </p>
        <p className="text-danger">
          <small>{t('Esta acción no se puede deshacer.')}</small>
        </p>
      </ModalBody>
      <ModalFooter>
        <Btn color="secondary" onClick={toggle}>
          {t('Cancelar')}
        </Btn>
        <Btn color="primary" onClick={onConfirm}>
          {t('Aceptar')}
        </Btn>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;

